import { Fragment, useContext, useEffect, useMemo, useState } from "react";
import { WaitingListFlowContext } from "../WaitingListFlowContext";
import Instructions from "./../partials/Instructions";
import { minuteToDays } from "../util";
import { waitinglist } from "../../../_Shared/Scripts/Endpoints";

const Introduction = () => {
    const { waitingListFlowContext, setWaitingListFlowContext } = useContext(
        WaitingListFlowContext
    );

    const urlParams = useMemo(() => {
        return new URLSearchParams(window.location.search);
    }, []);

    const pmcId = urlParams.get("pmcId");

    const formLang = {
        ...waitingListFlowContext.localization.global,
        buttons: {
            ...waitingListFlowContext.localization.global.buttons,
            ...waitingListFlowContext.localization.onlineBooking.buttons,
            ...waitingListFlowContext.localization.login.buttons,
        },
    };

    useEffect(() => {
        const fetchNextPosition = async () => {
            const response = await waitinglist.getNextAvailablePosition({
                pmcId,
            });
            if (response.status == 200) {
                setWaitingListFlowContext({
                    ...waitingListFlowContext,
                    waitingList: {
                        ...waitingListFlowContext.waitingList,
                        nextAvailablePosition: response.body.Position,
                    },
                });
            }
        };
        fetchNextPosition();
    }, [pmcId]);

    const startWaitingListFlow = () => {
        setWaitingListFlowContext({
            ...waitingListFlowContext,
            activeStep: waitingListFlowContext.paymentTerm.index,
        });
    };

    const instructions = [
        waitingListFlowContext.localization.global?.instructions?.working
            ?.step1,
        waitingListFlowContext.localization.global?.instructions?.working
            ?.step2,
        waitingListFlowContext.localization.global?.instructions?.working
            ?.step3,
    ];

    return (
        <div className="waitingListFlowPage__app introduction">
            <div className="introduction--title">
                <h1>
                    {
                        waitingListFlowContext.localization.global?.introduction
                            ?.title
                    }
                </h1>
            </div>
            <Instructions
                title={
                    waitingListFlowContext.localization.global?.instructions
                        ?.working?.title
                }
                instructions={instructions}
                note={waitingListFlowContext.localization.global?.instructions?.working?.note.replace(
                    "[ X ]",
                    minuteToDays(
                        waitingListFlowContext?.product?.ExpirationLimits
                            ?.WaitingListActivationPermitLock || 0
                    )
                )}
                titleLeft={true}
            />

            <button
                className="single-step__button single-step__button--next"
                data-booking-flow-step="ltp-selectproduct"
                onClick={startWaitingListFlow}
            >
                {formLang.buttons.nextStep}
            </button>
        </div>
    );
};

export default Introduction;
